import CryptoJS from "crypto-js";

const SECRET_KEY = "your-secret-key";

// URL-safe Base64 변환
function base64UrlEncode(base64) {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function base64UrlDecode(base64url) {
  let base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "=";
  return base64;
}

// 암호화
export function encryptUrlSafe(text) {
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  return base64UrlEncode(encrypted);
}

// 복호화
export function decryptUrlSafe(encryptedUrlSafe) {
  const encrypted = base64UrlDecode(encryptedUrlSafe);
  const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}
